import React from "react";
import { useNavigate } from "react-router-dom";
import { X, ArrowRight } from "lucide-react";
import { useCompare } from "@/lib/CompareContext";

export default function CompareDrawer() {
  const { items, remove, clear } = useCompare();
  const navigate = useNavigate();
  if (!items.length) return null;

  return (
    <div
      className="fixed bottom-0 inset-x-0 z-30 px-3 pb-3 sm:px-6 sm:pb-6"
      data-testid="compare-drawer"
    >
      <div className="glass shadow-2xl rounded-2xl p-3 sm:p-4 flex flex-col sm:flex-row items-stretch sm:items-center gap-3 max-w-5xl mx-auto">
        <div className="flex-1 flex items-center gap-2 overflow-x-auto">
          {items.map((p) => (
            <div key={p.slug} className="flex items-center gap-2 bg-white rounded-full pl-1 pr-3 py-1 border border-border" data-testid={`compare-item-${p.slug}`}>
              <img src={p.hero_image} alt="" className="w-7 h-7 rounded-full object-cover" />
              <span className="text-xs font-medium truncate max-w-[140px]">{p.name}</span>
              <button onClick={() => remove(p.slug)} className="text-ink/40 hover:text-terracotta" data-testid={`compare-remove-${p.slug}`}>
                <X className="w-3.5 h-3.5" />
              </button>
            </div>
          ))}
          {Array.from({ length: 3 - items.length }).map((_, i) => (
            <div key={i} className="text-xs text-ink/40 border border-dashed border-border rounded-full px-3 py-2">+ Add park</div>
          ))}
        </div>
        <div className="flex gap-2">
          <button onClick={clear} className="btn-ghost text-sm" data-testid="compare-clear">Clear</button>
          <button
            onClick={() => navigate(`/compare?ids=${items.map((p) => p.slug).join(",")}`)}
            className="btn-primary text-sm"
            data-testid="compare-go"
            disabled={items.length < 2}
          >
            Compare {items.length} parks <ArrowRight className="w-4 h-4" />
          </button>
        </div>
      </div>
    </div>
  );
}
